<template>
  <div>
    <div v-if="getMerchant.guest_profile_preference_position == 'SECOND_PAGE'" class="w-100 mb-4 bg-white pb-4 rounded-6 border-semi-grey box-shadow-light-aff p-3">
      <div class="row">
        <div class="col-1 align-self-center cursor-pointer" @click="previousStep()" v-if="show_back_button">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 8.75H4.7875L11.775 1.7625L10 0L0 10L10 20L11.7625 18.2375L4.7875 11.25H20V8.75Z" fill="#222222"/>
          </svg>
        </div>
        <div class="col-11 align-self-center">
          <p class="mb-0 body-1-4">Your Preference</p>
          <p class="mb-0 body-2-2-1">Please fill the form below to help us know your preferences.</p>
        </div>
      </div>
    </div>
    <div class="w-100">
      <div v-if="is_load" class="bg-white p-3 rounded-6 border-semi-grey box-shadow-light-aff">
        <loader />
      </div>
      <template>
        <div class="bg-white p-3 rounded-6 border-semi-grey mb-4 box-shadow-light-aff" v-for="(category,index_category) in data_list">
          <div class="w-100 pb-3 mb-3 border-b-semi-grey">
            <p class="body-1-4 mb-0 text-green">{{ category.name }}</p>
            <p class="mb-0 body-2-2-1" v-if="$isNotEmpty(category.description)">{{ category.description }}</p>
          </div>
          <ol class="pl-4">
            <template v-for="(qst,index) in category.question_list">
              <li class="w-100 pl-2 body-1-2" :id="qst.id" :class="{
                'mb-4 pb-3' : index+1 < category.question_list.length
              }">
                <div class="w-100 mb-2">
                  <p class="mb-0 body-1-2">{{$isNotEmpty(qst.name)?qst.name:qst.guest_profile_preference_question.name}}</p>
                  <span class="w-100 mb-0 body-3-3-1" v-if="$isNotEmpty(qst.description) || $isNotEmpty(qst.guest_profile_preference_question.description)">{{$isNotEmpty(qst.description)?qst.description:qst.guest_profile_preference_question.description}}</span>
                </div>
                <div class="row">
                  <template v-if="qst.guest_profile_preference_question.type == 'MULTIPLE_CHOICE' || qst.guest_profile_preference_question.type == 'CHOICE'">
                    <div class="col-6" v-for="ans in qst.preference_list">
                      <input @input="sendBackAnswer(index_category,index)" v-if="qst.guest_profile_preference_question.type == 'MULTIPLE_CHOICE'" type="checkbox" class="checkbox" :id="ans.id" :value="ans" v-model="data_list[index_category].question_list[index].answer">
                      <input @input="sendBackAnswer(index_category,index)" v-else type="radio" class="radio" :id="ans.id" :value="ans" v-model="data_list[index_category].question_list[index].answer"/>
                      <label :for="ans.id" class="body-2-2">{{ans.name}}</label>		
                    </div>
                    <div class="col-12" v-if="showOtherInput(qst,index)">
                      <span class="w-100 mb-0 body-3-3-1">Other {{ qst.name }} Preference:</span>
                      <textarea
                        @input="sendBackAnswer(index_category,index,true)"
                        class="form-control px-2 body-2 rounded-6 text-14 mb-2" 
                        rows="2" 
                        v-model="qst.preference_list[qst.preference_list.length-1].answer"
                        > 
                      </textarea>
                    </div>
                  </template>
                  <template v-else>
                    <div class="col-12">
                      <textarea @input="sendBackAnswer(index_category,index)" 
                        class="form-control px-2 body-2 rounded-6 text-14 mb-2" 
                        rows="2" 
                        v-model="data_list[index_category].question_list[index].answer"
                        > 
                      </textarea>
                    </div>
                  </template>
                </div>
                <div class="w-100 mt-2" v-if="qst.error != ''">
                  <p class="body-2 text-danger mb-0">{{ qst.error }}</p>
                </div>
              </li>
            </template>
          </ol>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';

  export default {
    props:{
      show_back_button:{
        type: Boolean,
        default: true
      },
      question:{
       default: () => [] 
      }
    },
    data(){
      return{
        is_load: true,
        data_list: [],
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
    },
    mounted(){
      this.loadFistData()
    },
    methods:{
      loadFistData(){
        this.is_load = true
        this.data_list = this.question
        setTimeout(()=>{
          this.is_load = false
        },300)
      },
      sendBackAnswer(index_category,index,is_other=false){
        let other_obj = is_other ? this.data_list[index_category].question_list[index].preference_list[this.data_list[index_category].question_list[index].preference_list.length-1] : {}
        let params = {
          index_category: index_category,
          index: index,
          answer: is_other ? other_obj.answer : this.data_list[index_category].question_list[index].answer,
          is_other: is_other
        }
        this.$emit('sendBackAnswer',params)
      },
      showOtherInput(qst,index){
        let return_data = false
        if(qst.type == 'CHOICE'){
          return_data = qst.answer.id && qst.answer.id == `other_${index}` 
        }else if(qst.type == 'MULTIPLE_CHOICE'){
          let is_other_checked = qst.answer.findIndex(x=>x.id == `other_${index}`)
          return_data = is_other_checked != -1
        }
        return return_data
      },
      previousStep(){
        this.$emit('previousStep')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/checkin/Preference.vue